import Vue from "vue";
import userFunctions from "@/functions/userFunctions";

var serverFunctions = {
  async getPostResponse(url, requestObject) {
    const result = await fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "post",
      body: JSON.stringify(requestObject),
    });
    const data = await result.json();
    this.processUiVersion(data.uiVersion);
    this.processBanFlag(data.isBanned);
    return data.result;
  },
  async getPostResponseAsync(url, requestObject, success, failure) {
    fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "post",
      body: JSON.stringify(requestObject),
    }).then(success, failure);
  },
  async getRawPostResponse(url, requestObject) {
    const result = await fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "post",
      body: JSON.stringify(requestObject),
    });
    const data = await result.json();
    this.processUiVersion(data.uiVersion);
    this.processBanFlag(data.isBanned);
    return data;
  },
  async getResponseAsync(url, success, failure) {
    fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "get",
    }).then(success, failure);
  },
  async getResponse(url) {
    const result = await fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "get",
    });
    const data = await result.json();
    this.processUiVersion(data.uiVersion);
    this.processBanFlag(data.isBanned);
    return data.result;
  },
  async getRawResponse(url) {
    const result = await fetch(process.env.VUE_APP_SERVER_URL + url, {
      method: "get",
    });
    const data = await result.json();
    this.processUiVersion(data.uiVersion);
    this.processBanFlag(data.isBanned);
    return data;
  },
  processUiVersion(uiVersion) {
    if (!uiVersion) {
      return;
    }

    let currentUiVersion = Vue.$cookies.get("uiVersion");
    if (!currentUiVersion) {
      //cookie not set, new user, set it
      Vue.$cookies.set("uiVersion", uiVersion, "1m");
      return;
    }

    if (currentUiVersion != uiVersion) {
      //ui Updated, reload
      Vue.$cookies.set("uiVersion", uiVersion, "1m");
      window.location.reload();
    }
  },
  processBanFlag(banFlag) {
    if (banFlag != null && banFlag == true) {
      userFunctions.logout();
      window.location.replace("/");
    }
  },
  getDataRequestObject(user, id) {
    return { user: user, id: id };
  },
  getUpdateLastViewedRequest(user, deviceId, activity) {
    return { user: user, deviceId: deviceId, activityType: activity };
  },
  getSearchForumRequestObject(user, searchText, pageSize, pageIndex) {
    return {
      user: user,
      searchText: searchText,
      pageSize: pageSize,
      pageIndex: pageIndex,
    };
  },
  getSearchForumBoardRequestObject(
    user,
    boardId,
    searchText,
    pageSize,
    pageIndex
  ) {
    return {
      user: user,
      boardId: boardId,
      searchText: searchText,
      pageSize: pageSize,
      pageIndex: pageIndex,
    };
  },
  getPagedDataRequestObject(user, id, pageSize, pageIndex) {
    return { user: user, id: id, pageSize: pageSize, pageIndex: pageIndex };
  },
  getNewTopicRequest(
    user,
    id,
    topicSubject,
    firstPostContent,
    postImages,
    topicSticky,
    topicAnnouncement
  ) {
    return {
      user: user,
      id: id,
      topicSubject: topicSubject,
      firstPostContent: firstPostContent,
      images: postImages,
      topicSticky: topicSticky,
      topicAnnouncement: topicAnnouncement,
    };
  },
  getUpdateNewsRequest(user, newsItem) {
    return { user: user, newsItem: newsItem };
  },
  getNewNewsRequest(user, title, content, images) {
    return {
      user: user,
      newsItem: { title: title, content: content, images: images },
    };
  },
  getNewJournalRequest(user, title, contents, issueDate, pdfFile, coverImage) {
    return {
      user: user,
      newsLetterItem: {
        title: title,
        contents: contents,
        issueDate: issueDate,
        pdfFile: pdfFile,
        coverImage: coverImage,
      },
    };
  },
  getUpdateJournalRequest(user, newsLetterItem) {
    return { user: user, newsLetterItem: newsLetterItem };
  },
  moveTopicRequest(user, topicId, newBoardId) {
    return { user: user, topicId: topicId, newBoardId: newBoardId };
  },
  getUpdatePasswordRequest(user, oldPassword, newPassword) {
    return { user: user, oldPassword: oldPassword, newPassword: newPassword };
  },
  getAdminUpdatePasswordRequest(user, email, newPassword) {
    return { user: user, email: email, newPassword: newPassword };
  },
  getPostRequest(user, id, postContent, topicTitle, postImages) {
    return {
      user: user,
      id: id,
      postContent: postContent,
      topicTitle: topicTitle,
      images: postImages,
    };
  },
  getReportPostRequest(user, boardId, topicId, id, message) {
    return {
      user: user,
      boardId: boardId,
      topicId: topicId,
      id: id,
      message: message,
    };
  },
  getUpdateUserDataRequestObject(requestingUser, updatedUser) {
    return { user: requestingUser, updatedUser: updatedUser };
  },
  getUserActivityRequestObject(requestingUser, requestedUser) {
    return { user: requestingUser, requestedUser: requestedUser };
  },
  getLinkRequestObject(requestingUser, linkItem) {
    return {
      user: requestingUser,
      linkId: linkItem.linkId,
      linkTypeId: linkItem.linkTypeId,
      link: linkItem.link,
      linkText: linkItem.linkText,
      linkDescription: linkItem.linkDescription,
      countryId: linkItem.countryId,
    };
  },
  getSendMailRequestObject(
    requestingUser,
    messageId,
    userToId,
    subject,
    message
  ) {
    return {
      user: requestingUser,
      mailToSend: {
        messageId: messageId,
        userTo: userToId,
        subject: subject,
        message: message,
      },
    };
  },
  getContactModeratorsRequest(name, email, subject, message) {
    return { name: name, email: email, subject: subject, messageBody: message };
  },
  getUploadUrlRequest(user, filename) {
    return { user: user, filename: filename };
  },
  getUploadImageRequest(user, filename, filetype, filedata) {
    return {
      user: user,
      filename: filename,
      filetype: filetype,
      filedata: filedata,
    };
  },
  getRotatePostImageRequest(user, postId, imagePath, degrees) {
    return {
      user: user,
      postId: postId,
      imagePath: imagePath,
      degrees: degrees,
    };
  },
  getRotateImageRequest(user, imagePath, degrees) {
    return { user: user, imagePath: imagePath, degrees: degrees };
  },
  getSendPasswordResetLinkRequest(email) {
    return { emailAddress: email };
  },
  getUserSearchRequest(user, searchText) {
    return { user: user, searchText: searchText };
  },
  getResetPasswordRequest(token, password) {
    return { token: token, newPassword: password };
  },
  getConfirmRegistrationRequest(email, token) {
    return { email: email, token: token };
  },
  LINK_TYPE: {
    NURSERIES: 4,
    LINKS: 2,
  },
};

export default serverFunctions;
